export default "__VITE_ASSET__BNEidx69__"